import {Text} from '#component/base';
import {MultipleChoiceSelect} from '#component/partial/Wizard/component';

import {RatingSelectProps} from './RatingSelect.types';

import * as css from './RatingSelect.css';

export const RatingSelect = ({
  title,
  scaleFromLabel,
  scaleToLabel,
  options,
  value,
  indexQuestion,
  editQuestion,
  fullWidthOption,
  isMultipleChoice,
}: RatingSelectProps) => {
  return (
    <div>
      <div className={css.title}>
        <Text
          className={css.titleText}
          color="burgundy"
          variant="heading2"
          textAlign="center"
          fontWeight="light">
          {title}
        </Text>
      </div>
      <div className={css.optionsWrapper}>
        {scaleFromLabel && scaleToLabel && (
          <div className={css.labels}>
            <Text color="doveGray" variant="heading4" textAlign="center">
              {scaleFromLabel}
            </Text>
            <Text
              className={css.scaleToLabel}
              color="doveGray"
              variant="heading4"
              textAlign="center">
              {scaleToLabel}
            </Text>
          </div>
        )}
        <MultipleChoiceSelect
          name={title}
          onChange={({target: {value}}) => editQuestion([value], indexQuestion, isMultipleChoice)}
          value={value}
          options={options}
          optionType={isMultipleChoice ? 'checkbox' : 'radio'}
          fullWidthOption={fullWidthOption}
        />
      </div>
    </div>
  );
};
